import React, { useContext, useEffect, useRef, useState } from 'react'
import { AppHeaderDropdown } from '@coreui/react'
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  InputGroupAddon
} from 'reactstrap'
import { FormatMoney } from '../../services/Functions'
import { CartContext } from '../../context/cart.context'
import { useHistory } from 'react-router-dom'

const ShoppingCart = (props) => {
  const articleCodeConwayText = 'Código de Conway'
  const articleCodeCustomerText = 'Código de cliente'

  const history = useHistory()

  const cartContext = useContext(CartContext)

  const fasttrackInputRef = useRef()
  const dropdownRef = useRef()
  const unitInputsRef = useRef({})

  const [cartArticleCode, setCartArticleCode] = useState('')
  const [cartArticleUnits, setCartArticleUnits] = useState(1)
  const [isConwayArticleCodeType, setIsConwayArticleCodeType] = useState(true)
  const [articleCodeTypesOpen, setArticleCodeTypesOpen] = useState(false)
  const [articleCodeTypesText, setArticleCodeTypesText] = useState(articleCodeConwayText)
  const [unitInputs, setUnitInputs] = useState({})
  const [selectedItem, setSelectedItem] = useState(null)
  const [loadingCart, setLoadingCart] = useState(false)

  useEffect(() => {
    setUnitInputs(
      cartContext.cart.reduce(
        (previous, current) => ({ ...previous, [current.articleCode]: current.units }),
        {}
      )
    )
  }, [cartContext.cart])

  useEffect(() => {
    if (!unitInputsRef.current[selectedItem]) return
    unitInputsRef.current[selectedItem].select()
  }, [selectedItem])

  const handleViewProduct = (articleCode) => {
    dropdownRef.current.toggle()
    history.push(`/catalog/${articleCode}`)
  }

  const handleGoToCheckout = () => {
    history.push(`/checkout`)
  }

  const handleKeyDownArticleByCode = (ev) => {
    if (ev.key === 'Enter') {
      handleAddArticleByCode()
    }
  }

  const removeArticle = (ev, item) => {
    ev.preventDefault()
    ev.stopPropagation()
    if (loadingCart) return

    setLoadingCart(true)
    cartContext.removeFromCart(item).then(() => setLoadingCart(false))
  }

  const updateCartUnits = async (articleCode, units) => {
    if (loadingCart || units < 1 || units > 10000) return

    setLoadingCart(true)
    await cartContext.updateCart([{ articleCode: articleCode, units: units }])
    setLoadingCart(false)
  }

  const updateUnitsInput = (ev, item) => {
    const units = parseInt(ev.target.value, 10)
    if (loadingCart || units < 1 || units > 10000) return

    setUnitInputs({
      ...unitInputs,
      [item.articleCode]: parseInt(ev.target.value, 10)
    })
  }

  const focusUnits = (item) => {
    setSelectedItem(item.articleCode)
  }

  const setUnits = async (ev, item) => {
    if (ev.type === 'blur' || (ev.type === 'keydown' && ev.key === 'Enter')) {
      ev.preventDefault()
      ev.stopPropagation()
      setSelectedItem('')
      if (/^\d+$/.test(ev.target.value)) {
        const units = parseInt(ev.target.value, 10)
        if (units !== item.units) await updateCartUnits(item.articleCode, units)
      }
    }
  }

  const addUnit = async (ev, item) => {
    ev.preventDefault()
    ev.stopPropagation()
    await updateCartUnits(item.articleCode, item.units + 1)
  }

  const removeUnit = async (ev, item) => {
    ev.preventDefault()
    ev.stopPropagation()
    await updateCartUnits(item.articleCode, item.units - 1)
  }

  const handleKeyDownArticleCodeType = (ev, isConwayArticleCodeType) => {
    if (ev.key === 'Enter') {
      handleChangeArticleCodeType(isConwayArticleCodeType)
        .then(handleAddArticleByCode)
        .then(handleSwitchArticleCodeTypesOpen)
    }
  }

  const handleChangeArticleCodeType = (isConwayArticleCodeType) => {
    setIsConwayArticleCodeType(isConwayArticleCodeType)
    setArticleCodeTypesText(
      isConwayArticleCodeType ? articleCodeConwayText : articleCodeCustomerText
    )
  }

  const handleAddArticleByCode = async () => {
    if (!cartArticleCode.trim()) return

    setLoadingCart(true)
    await cartContext.addToCartWithFastrack(
      cartArticleCode,
      cartArticleUnits,
      isConwayArticleCodeType
    )
    setCartArticleCode('')
    setCartArticleUnits(1)
    fasttrackInputRef.current.focus()
    setLoadingCart(false)
  }

  const handleSwitchArticleCodeTypesOpen = () => {
    setArticleCodeTypesOpen(!articleCodeTypesOpen)
  }

  return (
    <AppHeaderDropdown direction="down" ref={dropdownRef}>
      <DropdownToggle
        nav
        style={{
          marginLeft: '10px',
          borderRight: '1px solid grey',
          paddingRight: '10px',
          cursor: 'pointer'
        }}
      >
        <img src="/shopping-cart.svg" style={{ width: 25 }} alt="Carrito" />
        {cartContext.cart.length !== 0 ? cartContext.cart.length : ''}
      </DropdownToggle>
      <DropdownMenu
        right
        style={{ right: 'auto', minWidth: 'calc(100vw / 3)', maxWidth: 'calc(100vw - 10px)' }}
      >
        <div
          style={{
            fontWeight: 'bold',
            paddingTop: 20,
            fontSize: 20,
            paddingLeft: 20,
            paddingBottom: 14
          }}
        >
          Mi pedido
        </div>
        <div style={{ padding: 10, display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ marginRight: 4 }}>
              <Dropdown
                isOpen={articleCodeTypesOpen}
                toggle={handleSwitchArticleCodeTypesOpen}
                size="sm"
              >
                <DropdownToggle caret color="default" onKeyDown={handleKeyDownArticleByCode}>
                  {articleCodeTypesText}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    key="category-type-0"
                    onClick={() => handleChangeArticleCodeType(true)}
                    onKeyDown={(ev) => handleKeyDownArticleCodeType(ev, true)}
                  >
                    {articleCodeConwayText}
                  </DropdownItem>
                  <DropdownItem
                    key="category-type-1"
                    onClick={() => handleChangeArticleCodeType(false)}
                    onKeyDown={(ev) => handleKeyDownArticleCodeType(ev, false)}
                  >
                    {articleCodeCustomerText}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div style={{ marginRight: 4 }}>
              <Input
                placeholder="Código"
                value={cartArticleCode}
                onKeyDown={handleKeyDownArticleByCode}
                onChange={(ev) => setCartArticleCode(ev.target.value)}
                bsSize="sm"
                ref={fasttrackInputRef}
              />
            </div>
            <div style={{ marginRight: 4 }}>
              <Input
                style={{ width: 85 }}
                placeholder="Cantidad"
                value={cartArticleUnits}
                type="number"
                onKeyDown={(ev) => handleKeyDownArticleCodeType(ev, false)}
                onChange={(ev) =>
                  setCartArticleUnits(Math.min(10000, Math.max(1, parseInt(ev.target.value, 10))))
                }
                onClick={(ev) => ev.target.select()}
                bsSize="sm"
              />
            </div>
            <Button onClick={handleAddArticleByCode} size="sm">
              Añadir articulo
            </Button>
          </div>
        </div>
        {cartContext.cart.length === 0 ? (
          <div
            className="m-4 text-center"
            style={{
              color: '#e60017',
              fontSize: 16
            }}
          >
            No hay productos en el carrito.
          </div>
        ) : (
          <div style={{ overflowY: 'auto', maxHeight: '60vh' }} className="p-2">
            <table style={{ width: '100%', overflow: 'hidden' }}>
              <tbody>
                {cartContext.cart.map((item, index) => (
                  <tr key={`cart-item-${index}`}>
                    <td
                      style={{ width: '50%', cursor: 'pointer' }}
                      onClick={() => {
                        if (item.totalPrice) {
                          handleViewProduct(item.articleCode)
                        }
                      }}
                    >
                      {item.title}
                    </td>
                    <td style={{ width: '20%' }}>
                      <div className="ml-1 mr-1">
                        {window.innerWidth >= 1100 ? (
                          <InputGroup size="sm" style={{ justifyContent: 'center', width: 90 }}>
                            <InputGroupAddon addonType="prepend">
                              <Button onClick={(ev) => removeUnit(ev, item)}>-</Button>
                            </InputGroupAddon>
                            <Input
                              innerRef={(element) =>
                                (unitInputsRef.current[item.articleCode] = element)
                              }
                              style={{ maxWidth: 60 }}
                              className="text-center"
                              placeholder=""
                              value={unitInputs[item.articleCode] || 0}
                              readOnly={selectedItem !== item.articleCode}
                              onChange={(ev) => updateUnitsInput(ev, item)}
                              onKeyDown={(ev) => setUnits(ev, item)}
                              onBlur={(ev) => setUnits(ev, item)}
                              onFocus={(_) => focusUnits(item)}
                              onClick={(_) => focusUnits(item)}
                            />
                            <InputGroupAddon addonType="append">
                              <Button onClick={(ev) => addUnit(ev, item)}>+</Button>
                            </InputGroupAddon>
                          </InputGroup>
                        ) : (
                          <React.Fragment>
                            <span>{' x '}</span>
                            <b>{item.units}</b>
                          </React.Fragment>
                        )}
                      </div>
                    </td>
                    {props.showMoney && (
                      <td style={{ width: '20%', color: '#e60017', fontSize: 18 }}>
                        {FormatMoney(item.taxBase, '- €', !item.taxBase)}
                      </td>
                    )}
                    <td style={{ width: '10%' }}>
                      <Button
                        color="link"
                        style={{ width: '20%' }}
                        onClick={(ev) => removeArticle(ev, item)}
                      >
                        <i className="icon-trash" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="p-4 text-right">
          <Button color="danger" onClick={handleGoToCheckout}>
            Revisar pedido
          </Button>
        </div>
      </DropdownMenu>
    </AppHeaderDropdown>
  )
}

export default ShoppingCart
